import axios from '../../../../utills/axiosConfig';

export const fetchSieveSizes = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/sieve-sizes', { params });
  return res.data;
};

export const addSieveSize = async (sieveSize) => {
  try {
    const res = await axios.post('/sieve-sizes', sieveSize);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateSieveSize = async (id, sieveSize) => {
  const res = await axios.put(`/sieve-sizes/${id}`, sieveSize);
  return res.data;
};

export const deleteSieveSize = async (id) => {
  const res = await axios.delete(`/sieve-sizes/${id}`);
  return res.data;
};

export const importSieveSizeCSV = async (formData) => {
  const { data } = await axios.post('/sieve-sizes/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 